import { useEffect, useState } from 'react'

// iOS Safari one-time banner explaining "Share → Add to Home Screen" so
// users get the standalone PWA treatment. Android shows a native install
// prompt (handled in InstallPrompt.tsx); iOS gives no native UI for this.
//
// Dismisses on tap or auto after 30s. Won't show again for 30 days once
// dismissed.

const STORAGE_KEY = 'ss.ios_hint_dismissed_at'
const RESHOW_DAYS = 30

function isIosSafari() {
  if (typeof window === 'undefined') return false
  const ua = window.navigator.userAgent
  const isIos = /iPad|iPhone|iPod/.test(ua)
  // iPadOS reports as Mac — detect via touch
  const isIpadPretendingMac = /Macintosh/.test(ua) && 'ontouchend' in document
  const isSafari = /^((?!chrome|android|crios|fxios|edgios).)*safari/i.test(ua)
  return (isIos || isIpadPretendingMac) && isSafari
}
function isStandalone() {
  if (typeof window === 'undefined') return false
  return (window.matchMedia('(display-mode: standalone)').matches
    || (window.navigator as any).standalone === true)
}

export default function IosInstallHint() {
  const [show, setShow] = useState(false)

  useEffect(() => {
    if (!isIosSafari() || isStandalone()) return
    try {
      const dismissed = parseInt(localStorage.getItem(STORAGE_KEY) || '0', 10)
      if (dismissed && Date.now() - dismissed < RESHOW_DAYS * 24 * 60 * 60 * 1000) return
    } catch {}
    setShow(true)
    const t = setTimeout(() => setShow(false), 30000)
    return () => clearTimeout(t)
  }, [])

  function dismiss() {
    setShow(false)
    try { localStorage.setItem(STORAGE_KEY, String(Date.now())) } catch {}
  }

  if (!show) return null
  return (
    <div style={{
      position: 'fixed', bottom: 'calc(72px + env(safe-area-inset-bottom))', left: 12, right: 12, zIndex: 60,
      background: 'var(--ink)', color: '#fff', padding: '12px 14px', borderRadius: 12,
      boxShadow: '0 8px 24px rgba(0,0,0,0.25)', display: 'flex', alignItems: 'center', gap: 12,
    }}>
      <div style={{ flex: 1, fontSize: 13, lineHeight: 1.35 }}>
        <strong style={{ display: 'block', fontSize: 14, marginBottom: 2 }}>Install Signed and Sorted</strong>
        Tap the Share button <span style={{ display: 'inline-block', padding: '0 4px', background: 'rgba(255,255,255,0.18)', borderRadius: 4, fontSize: 12 }}>↑</span>, then "Add to Home Screen". Works offline, fits like a real app.
      </div>
      <button onClick={dismiss} aria-label="Dismiss"
        style={{ background: 'transparent', border: 'none', color: '#fff', fontSize: 22, padding: '0 4px', cursor: 'pointer' }}>×</button>
    </div>
  )
}
